<template>
  <section class="td-banner" :style="box">
    <div class="banner-bg-image" :class="container" :style="getImage">
      <router-link :to="blog" class="btn-back-page"/>
      <div class="td-banner__content">
        <div class="container-middle">
          <div v-if="authorImage" class="td-banner__avatar">
            <img :src="authorImage" alt class="td-banner__avatar-img" @error="resetAuthorPic"/>
          </div>
          <div class="td-banner__column">
            <h1 class="td-banner__title">{{ title }}</h1>
            <ul class="td-banner__breadcrumbs">
              <li class="td-banner__breadcrumb">
                <a style="cursor: default;">{{ authorName }}</a>
              </li>

              <li class="td-banner__breadcrumb" v-for="(item, idx) in breadcrumbs" :key="idx">
                <!-- Default link -->
                <router-link v-if="item.link && !item.blank" :to="item.link" v-text="item.text"/>

                <!-- Link is target blank -->
                <a
                    v-if="item.link && item.blank"
                    :href="item.link"
                    target="_blank"
                    v-text="item.text"
                />

                <!-- Without link -->
                <a v-if="!item.link" v-text="item.text"/>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import convertDate from "@/helpers/convertDate";
import convertCategory from "@/helpers/convertCategory";
import mixin from "@/mixins/sections/styleSettings";

// Routes Names
import {blog} from "@/staticData/routesName/blog";
import getBlogImg from "@/helpers/getBlogImg";
import getBaseUrl from "@/helpers/getBaseUrl";

export default {
  mixins: [mixin],
  methods: {
    resetAuthorPic() {
      if (this.profile) {
        this.mainDataPage.author.profile.pic = null;
      }
    },
  },
  computed: {
    ...mapGetters("blog", {
      mainDataPage: "GET_MAIN_DATA_SIMPLE_PAGE"
    }),
    ...mapState({
      imageUrl:(state)=>state.imageUrl
    }),
    blog() {
      const routeElements = this.$route.path.split('/')
      return `${blog}/${routeElements[routeElements.length - 2]}`
    },
    // hasData to be in mixin
    image() {
      return this.mainDataPage.img;
    },
    authorName() {
      return this.profile ? this.profile.full_name : null;
    },
    authorImage() {
      let baseUrl = getBaseUrl();
      return this.profile && this.profile.pic ? `${baseUrl}/img/profile/pic/` + this.profile.pic : false;
      // return this.mainDataPage.author && this.mainDataPage.author.img
      //   ? this.mainDataPage.author.img
      //   : false
    },
    profile() {
      return this.mainDataPage.author ? this.mainDataPage.author.profile : null;
    },
    title() {
      return this.mainDataPage.title;
    },
    getImage() {
      const url = getBlogImg(this.image, 'big') || this.imageUrl + '/img/blog/big_not_img.png'
      return `background-image: url("${url}")`
    },
    category() {
      return this.mainDataPage && this.mainDataPage.category;
    },
    car() {
      return this.mainDataPage && this.mainDataPage.car;
    },
    brand() {
      return (
          this.mainDataPage &&
          this.mainDataPage.car &&
          this.mainDataPage.car.brand
      );
    },
    breadcrumbs() {
      const fullDate = this.mainDataPage.date;
      const newDate = convertDate(fullDate);
      const newcategory = convertCategory(this.mainDataPage.categoryId);

      const modelText = this.car
          ? this.car.brand + " " +
          this.car.model_class + " " +
          (this.car.model_name || '')
          : "";

      const modelLink =
          this.car && this.car.model_page ? this.car.model_page : "";

      console.log('this.mainDataPage',this.mainDataPage);
      // Breadcrumbs
      const obj = {
        author: {
          text: "",
          link: ""
        },
        // category: {
        //   text: this.mainDataPage.subCategory,
        //   link: `${blog}/${newcategory.url}`
        // },
        category: {
          text: this.mainDataPage.category,
          link: `${blog}/${newcategory.url}`
        },
        model: {
          text: modelText,
          link: modelLink,
          blank: true
        },
        date: {
          text: newDate,
          link: ""
        }
      };

      let breadcrumbs = [];

      for (const key in obj) {
        if (obj[key].text) {
          breadcrumbs.push(obj[key]);
        }
      }

      return breadcrumbs;
    }
  }
};
</script>
